<h1 mat-dialog-title>{{ "recall.Recall" | translate }}</h1>
<mat-dialog-content>
  <h3>{{ "recall.Message" | translate }}</h3>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="buttons">
    <button mat-flat-button mat-dialog-close>Close</button>
    <button mat-raised-button class="ms-2" color="primary" (click)="onRecall()">
      {{ "recall.Recall" | translate }}
    </button>
  </div>
</mat-dialog-actions>
